
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 511.999 511.999"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M412.41 0H99.589C47.531 0 5.332 42.201 5.332 94.257v205.172c0 52.057 42.201 94.257 94.257 94.257h44.894a3.867 3.867 0 013.867 3.867V498.76c0 11.966 14.637 17.768 22.834 9.05l106.188-112.906a3.866 3.866 0 012.818-1.218h132.22c52.057 0 94.257-42.201 94.257-94.257V94.257C506.667 42.201 464.466 0 412.41 0z","fill":"#ec5569"}}),_c('path',{attrs:{"d":"M188.005 358.509c0-2.249-1.676-4.072-3.744-4.072h-43.462c-50.396 0-91.25-44.439-91.25-99.257V39.123c0-9.276 1.174-18.253 3.361-26.77C24.489 28.587 5.332 59.184 5.332 94.257v205.172c0 52.056 42.201 94.257 94.257 94.257h44.894a3.867 3.867 0 013.867 3.867V498.76c0 11.966 14.637 17.768 22.834 9.05l16.82-17.885V358.509h.001z","fill":"#e63950"}}),_c('path',{attrs:{"d":"M361.908 122.325c-23.931-23.931-62.731-23.931-86.663 0l-13.518 13.518a8.255 8.255 0 01-11.673 0l-13.302-13.302c-23.931-23.931-62.731-23.931-86.663 0-23.931 23.931-23.931 62.731 0 86.663l99.973 99.973a8.255 8.255 0 0011.673 0l100.172-100.189c23.932-23.932 23.932-62.731.001-86.663z","fill":"#ec5569"}}),_c('path',{attrs:{"d":"M361.908 122.325c-23.931-23.931-62.731-23.931-86.663 0l-13.518 13.518a8.255 8.255 0 01-11.673 0l-13.302-13.302c-23.931-23.931-62.731-23.931-86.663 0-23.931 23.931-23.931 62.731 0 86.663l99.973 99.973a8.255 8.255 0 0011.673 0l100.172-100.189c23.932-23.932 23.932-62.731.001-86.663z","fill":"#fff5f5"}}),_c('path',{attrs:{"d":"M182.145 209.204c-23.931-23.931-23.931-62.731 0-86.663a60.966 60.966 0 0127.303-15.807c-20.486-5.532-43.278-.274-59.358 15.807-23.931 23.931-23.931 62.731 0 86.663l99.973 99.973a8.255 8.255 0 0011.673 0l10.19-10.192-89.781-89.781z","fill":"#dce6eb"}})])
          )
        }
      }
    